<template>
  <div class="sponsor">
    <div class="main">
      <img class="ufc" src="@/assets/img/logo-ufc-light.svg">
      <BaseText4 class="subtitle" text="Official sponsor"/>
    </div>
    <img class="reebok" src="@/assets/img/logo-reebok.svg">
  </div>
</template>

<script>
import BaseText4 from '@/components/BaseText4/BaseText4'
export default {
  components: {
    BaseText4
  }
}
</script>

<style lang="scss" scoped>
.sponsor {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0 0 0;
  .ufc {
    display: block;
    margin-bottom: 0.5rem;
    height: 1rem;
  }
  .reebok {
    display: block;
    height: 1rem;
  }
}
</style>
